<template>
  <CustomPage title="关于我们">
    <div slot="content" class="content">
      <div v-html="html" class="about-us-html"></div>
    </div>
  </CustomPage>
</template>

<script>
import CustomPage from '@/components/custom-page.vue'
import { getAboutUs } from '@/api/mine'
export default {
  components: { CustomPage },
  data() {
    return {
      html: null
    }
  },
  created() {
    this.getData()
  },
  methods: {
    getData() {
      const params = {
        platformInfoType: 0,
      }
      this.$store.dispatch('app/showLoading')
      getAboutUs(params)
        .then(res => {
          this.$store.dispatch('app/hideLoading')
          this.html = res.data[0]?.content
        })
        .catch(() => {
          this.$store.dispatch('app/hideLoading')
        })
    }
  },
}
</script>

<style lang="less" scoped>
.content {
  padding: 22px 24px;
}
</style>
<style lang="less">
.about-us-html {
  img {
    display: block !important;
    margin: 0 auto !important;
    max-width: 100% !important;
  }
}
</style>